import PayMethodsList from './PayMethodsList';

export default PayMethodsList;
